/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by rwilliams on 4/27/17.
 */

'use strict';

function PaginationControlsController (
    _
) {

    var MAX_DROPDOWN_SIZE = 1000;
	var self = this;


	//=========//
	// General //
	//=========//

	self.isDisabled = function () {
		return self.disabled || false;
	};

	self.isMultiPage = function () {
		return !!self.pagingOptions && self.pagingOptions.contentTotal !== 0;
	};

    self.showPageNumberAsText = function () {
        //
        // TODO ABC-11744:
        //  If previous screen had a lot of entries in totalPagesArray,
        //  a new screen with pagination might display all of those entries
        //  and freeze the UI for a few seconds.
        //      To properly fix this issue,
        //      we should optimize the dropdown instead.
        //
        return (
            self.pageNumberIsTextInput ||
            _.chain(self)
                .get('pagingOptions.totalPagesArray')
                .size()
                .value() > MAX_DROPDOWN_SIZE
        );
    };


	//======================//
	// Previous Page Button //
	//======================//

	self.isPrevBtnDisabled = function () {
		return !!self.pagingOptions && self.pagingOptions.currentPage === 1;
	};

	self.onPrevBtnClicked = function ($event) {
		// ensure button doesn't stay focused
		$event.target.blur();

		if (!self.isPrevBtnDisabled()) {
			self.prevPageHandler();
		}
	};


	//==================//
	// Next Page Button //
	//==================//

	self.isNextBtnDisabled = function () {
		return !!self.pagingOptions && self.pagingOptions.currentPage === self.pagingOptions.totalPages;
	};

	self.onNextBtnClicked = function ($event) {
		// ensure button doesn't stay focused
		$event.target.blur();

		if (!self.isNextBtnDisabled()) {
			self.nextPageHandler();
		}
	};


	//====================//
	// Page Size Selector //
	//====================//

	self.onPageSizeChanged = function () {
		if (!!self.pageSizeChangeHandler) {
			self.pageSizeChangeHandler();
		}
	};


	//========================//
    // Page Number Text Input //
    //========================//

    self.onPageNumberTextInputKeyDown = ($event) => {
        if ($event.keyCode === 13) {
            $event.target.blur();
            $event.preventDefault();

            let currentPageNum = _.parseInt(self.pagingOptions.currentPage);
            if (isNaN(currentPageNum) || currentPageNum < 1) {
                currentPageNum = 1;
            }
            self.pagingOptions.currentPage = currentPageNum;

            self.jumpToPageHandler();
        }
    };

}


angular
.module('prism-ui.components.navigation')
.component('paginationControls', {
	templateUrl: 'components/navigation/pagination/pagination-controls-template.html',
	controller: PaginationControlsController,
	bindings: {
		nextPageHandler: '&',
		prevPageHandler: '&',
		jumpToPageHandler: '&',
		pageSizeChangeHandler: '&',
        pageNumberIsTextInput: '<',
		pagingOptions: '=',
		disabled: '<',
	}
});
